module.exports = __webpack_public_path__ + "static/media/bag.6e773b18.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bag.png
// module id = 791
// module chunks = 0